/**
 * MIS recipients API — agent self-service for the list of email addresses
 * that receive MIS reports for their affiliate_code.
 *
 * Replaces the old admin-only mis-admin/channels/* endpoints (removed).
 * The backend upserts the row in mis_channel_config_{stage} and creates the
 * item on first save, seeding `name` from the agent record and defaulting
 * `emails` to the agent's own email when the agent submits an empty list.
 */

import { BaseApi } from "./base.api";
import { LOS_API_BASE_URL } from "@/config";
import type {
  UpdateAgentMisRecipientsRequest,
  UpdateAgentMisRecipientsResponse,
} from "@/types/misRecipients.types";

const EMPTY_MIS_RECIPIENTS = { emails: [] };

class MisRecipientsApi extends BaseApi {
  constructor() {
    super(LOS_API_BASE_URL);
  }

  /**
   * Upsert the MIS report recipient list for the calling agent.
   * Endpoint: POST /update_agent_mis_recipients
   */
  async updateAgentMisRecipients(
    request: UpdateAgentMisRecipientsRequest,
  ): Promise<UpdateAgentMisRecipientsResponse> {
    const response = await this.post<UpdateAgentMisRecipientsResponse>(
      "/update_agent_mis_recipients",
      request,
      true,
    );

    if (response.success && response.data) {
      return response.data;
    }
    return {
      status: "Error",
      message: response.message || "Failed to update MIS recipients",
      response: EMPTY_MIS_RECIPIENTS,
    };
  }
}

export { MisRecipientsApi };
export const misRecipientsApi = new MisRecipientsApi();
